import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { OccupationsAction } from "./occupations.action";
import { OccupationsState } from "./occupations.model";

const INITIAL_STATE: OccupationsState = {
	occupations: [],
};

export const occupationsReducer = createReducer(
	INITIAL_STATE,
	on(OccupationsAction.getAllSuccess, (state, { occupations }) => updateState(state, { occupations }))
);
